import { ModalMain, ModalContent, ModalTopAndBottom, ModalTitle, ModalBody, Modalfooter } from '../../styledComponents/modalStyled'
import { BaseBtn, BaseBtnLink, BaseBtnLinkRed } from '../../styledComponents/globalStyled'
import ImageCarousel from './imageCarousel'
import { FaSteam } from "react-icons/fa";
import '../../theme/core.css'
export default function GalleryModal(props: any) {


    if (!props.show) {
        return null;
    }

    return (
        <>
            <ModalMain>
                <ModalContent>
                    <ModalTopAndBottom>
                        <ModalTitle>
                            {props.info.title}
                        </ModalTitle>
                    </ModalTopAndBottom>
                    <ImageCarousel imageArray={props.info.images} />
                    {/* <img src={props.info.images[props.info.images.length - 1]} alt="" /> */}

                    <ModalBody>
                        {props.info.description}
                    </ModalBody>
                    <Modalfooter>
                        {(props.info.playstore) ?
                            <a href={props.info.playstore} rel="noreferrer" target="_blank" style={{ textDecoration: 'none' }}>
                                <BaseBtnLink >PlayStore</BaseBtnLink>
                            </a>
                            : <></>}
                        {(props.info.itchio) ?
                            <a href={props.info.itchio} rel="noreferrer" target="_blank" style={{ textDecoration: 'none' }}>
                                <BaseBtnLink >itch.io</BaseBtnLink>
                            </a>
                            : <></>}
                        {(props.info.steam) ?
                            <a href={props.info.steam} rel="noreferrer" target="_blank" style={{ textDecoration: 'none' }}>
                                <BaseBtnLink ><FaSteam style={{ fontSize: "15px" }} /> Steam</BaseBtnLink>
                            </a>
                            : <></>}
                        <BaseBtn>
                            <BaseBtnLinkRed onClick={props.onClose}  >Close</BaseBtnLinkRed>
                        </BaseBtn>
                    </Modalfooter>
                </ModalContent>
            </ModalMain>

        </>
    );
}
